<template>
  <van-dialog
    v-model="isShowItms"
    :showConfirmButton="false"
    :showCancelButton="false"
    @click-overlay="hide"
    className="dialog-box"
  >
    <template #title>
      <div></div>
    </template>
    <div class="content">
      <div class="main">
        <slot></slot>
      </div>
    </div>
    <div class="colse">
      <div class="hide" @click="hide">
        <img src="@/assets/mybox/home/colse.png" />
      </div>
    </div>
  </van-dialog>
</template>
<script>
export default {
  props: {
    isShow: {
      type: Boolean,
    },
    title: {
      type: String,
      default: "Rules",
    },
  },
  data() {
    return {
      isShowItms: this.isShow,
    };
  },
  watch: {
    isShow() {
      this.isShowItms = this.isShow;
    },
  },
  methods: {
    hide() {
      this.$emit("hide");
    },
    submit() {
      this.$emit("submit");
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog-box {
  width: 90%;
  background-color: transparent !important;
}

.header {
}
.content {
  min-width: 80%;
  min-height: 5rem;
  border-radius: 15px;
}
::v-deep .van-dialog {
}
::v-deep .van-dialog__header {
  padding-top: 0;
}
.colse {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 0.4rem;
  .hide {
    width: 0.6rem;
    height: 0.6rem;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
